import { render, staticRenderFns } from "./settingRow.vue?vue&type=template&id=afcf2a08&scoped=true&"
import script from "./settingRow.vue?vue&type=script&lang=js&"
export * from "./settingRow.vue?vue&type=script&lang=js&"
import style0 from "./settingRow.vue?vue&type=style&index=0&id=afcf2a08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afcf2a08",
  null
  
)

export default component.exports